export default __webpack_public_path__ + "static/media/01.20cba2c3.jpg";